import React from 'react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import bankAccounts from 'modules/payroll_bundle/store/collections/bankAccounts'
import paymentItems from 'modules/payroll_bundle/store/collections/paymentItems'
import payments from 'modules/payroll_bundle/store/collections/payments'

export const useFetchPaymentData = (periodIdList?: string[]) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const { currentPolicyPeriods, periodIndex } = usePolicyPeriods()

  const fetchData = async () => {
    setIsLoading(true)

    const policyPeriodId = currentPolicyPeriods[periodIndex]?.id

    const data = {
      data: {
        policy_period_ids: periodIdList ? periodIdList : [policyPeriodId],
      },
    }

    await Promise.all([
      bankAccounts.fetch(),
      payments.fetch(data),
      paymentItems.fetch(data),
    ]).finally(() => setIsLoading(false))
  }

  useUnsafeEffect(() => {
    fetchData()
  }, [periodIndex]) // eslint-disable-line react-hooks/exhaustive-deps

  return { isLoading, fetchData }
}
